const setCatalogo54 = (state, catalogo54) => {
  state.catalogo54 = catalogo54;
}

const setCatalogo59 = (state, catalogo59) => {
  state.catalogo59 = catalogo59;
}

const setCatalogo06 = (state, catalogo06) => {
  state.catalogo06 = catalogo06;
}

const setCatalogo07 = (state, catalogo07) => {
  state.catalogo07 = catalogo07;
}

const setCatalogo09 = (state, catalogo09) => {
  state.catalogo09 = catalogo09;
}

const setCatalogo10 = (state, catalogo10) => {
  state.catalogo10 = catalogo10;
}

const setCatalogo17 = (state, catalogo17) => {
  state.catalogo17 = catalogo17;
}

const setCatalogo18 = (state, catalogo18) => {
  state.catalogo18 = catalogo18;
}

const setCatalogo20 = (state, catalogo20) => {
  state.catalogo20 = catalogo20;
}
const setCatalogo63 = (state, catalogo63) => {
  state.catalogo63 = catalogo63;
}
const setCatalogo64 = (state, catalogo64) => {
  state.catalogo64 = catalogo64;
}

const setUbigeo = (state, ubigeo) => {
  state.ubigeo = ubigeo;
}

const setOficinas = (state, oficinas) => {
  state.oficinas = oficinas;
}

const setOfs = (state, ofs) => {
  state.ofs = ofs;
}
const setClientes = (state, clientes) => {
  state.clientes = clientes;
}
const setProductos = (state, productos) => {
  state.productos = productos;
}
const setUbigeoTotal = (state, ubigeoTotal) => {
  state.ubigeoTotal = ubigeoTotal;
}

const setCuentas = (state, cuentas) => {
  state.cuentas = cuentas;
}

const setParametros = (state, parametros) => {
  state.parametros = parametros;
}


export default {
  setCuentas,
  setCatalogo54,
  setCatalogo59,
  setCatalogo06,
  setCatalogo07,
  setCatalogo09,
  setCatalogo10,
  setCatalogo17,
  setCatalogo18,
  setCatalogo20,
  setCatalogo63,
  setCatalogo64,
  setUbigeo,
  setUbigeoTotal,
  setParametros,
  setOficinas,
  setOfs,
  setClientes,
  setProductos
};



// WEBPACK FOOTER //
// ./src/store/modules/catalogos/mutations.js